import {
  CardBuilderProps,
  ComponentNames as CardComponentNames,
} from 'components/CardBuilder';
import {
  findComponentByName,
  findContentfulFlagValue,
} from 'components/PageSections/utils';
import { Promo } from 'utils/helpers/activePromoHelpers';
import { Section } from 'utils/types/contentfulTypes';

import { ProgramSectionProps } from './ProgramSection';
import {
  parseCarouselCards,
  parseBulletPoints,
  parseAccordionCards,
  createCardComponents,
} from './ProgramSection.utils';

export default function parseProgramSection(
  props: Section,
  advertisedPromos?: Promo[],
): ProgramSectionProps {
  const { metadata, subsections } = props;
  const { title, description, flags } = metadata ?? {};

  const disableAccordion = findContentfulFlagValue(
    'disableAccordion',
    flags as Queries.ContentfulFlag001[],
  );

  const bulletPointsSubsection = findComponentByName(
    subsections,
    'BulletPointWithIcon',
  );

  const cardsSubsection = findComponentByName(
    subsections,
    'CardsCarouselAccordion',
  );

  const cardGroups = cardsSubsection?.subsections ?? [];

  const cardGroupsItems = createCardComponents(
    cardGroups,
    advertisedPromos,
  ) as Array<CardBuilderProps<CardComponentNames>[]>;

  const accordionCards =
    cardGroupsItems && parseAccordionCards(cardGroupsItems);

  const carouselCards = cardGroupsItems && parseCarouselCards(cardGroupsItems);

  const bulletPoints =
    bulletPointsSubsection && parseBulletPoints(bulletPointsSubsection);

  return {
    title: title ?? '',
    description: description?.description ?? '',
    backgroundColor: metadata?.theme?.backgroundColor,
    bulletPoints,
    accordionCards,
    carouselCards,
    disableAccordion,
  };
}
